import React from 'react';
import moment from 'moment';
import $ from 'jquery';

import { PresenterReadReservationCheck } from '../../../../home/presenter.js';
import { ReadPropsReservationCheck } from '../../../../home/helper/request.props.js';

import Presenter from '../../../ChatSidebar/presenter.js';
import RequestProperties from '../../../ChatSidebar/helper/request.props.js';

import Linkify from './Linkify.jsx';
import Notify from '../../../../config/notify.js';
import Module from '../../../../utils/Render.js';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.min.css';

import ModalReasign from '../../../../home/helper/component/Modal/ModalReasign.js';

export default class ChatBox extends React.Component {
	constructor(props){
		super(props);
		this.state = {
			listMessage 	: [],
			loadingLoadMore : false,
			modalReassign 	: false,
			msgCounter 		: 0,
			assetData 		: null, 	
			userData 		: null,
		};
		this.msgElement 		= [];
		this.msgData 			= [];
		this.msgCount 			= 0;
		this.newScrollHeight 	= 0;
		this.isMinimize 		= false;
		this.nextUrl 			= this.props.NextUrl;

		this.loadingLoadMore 	= this.loadingLoadMore.bind(this);
		this.handleScroll 		= this.handleScroll.bind(this);
		this.scrollToBottom 	= this.scrollToBottom.bind(this);

		this.onRegisterMessageSuccess 	= this.onRegisterMessageSuccess.bind(this);
		this.onRegisterMessageFailed 	= this.onRegisterMessageFailed.bind(this);

		this.onReservationCheckSuccess = this.onReservationCheckSuccess.bind(this);
		this.onReservationCheckFailed = this.onReservationCheckFailed.bind(this);

		this.toggleOpenModalReassign = this.toggleOpenModalReassign.bind(this);
	};

	toggleChatBox(){
		this.isMinimize 	= !this.isMinimize
		if(this.isMinimize){
			this.msgCount 	= this.msgData.length;
		}else{
			this.msgCount 	= 0;
			this.setState({
				msgCounter 	: 0
			});
		}
		$(this.refs['chatBody']).slideToggle(300,'swing');
	};

	toggleCloseChatBox(e){
		e.preventDefault();
		$(this.refs['chatBox']).fadeOut(300);
		setTimeout(() => this.props.OnClose(this.props.UserData), 300);
	};

	toggleCloseModalReassign(){
		this.setState({
			assetData 		: null,
			userData 		: null,
			modalReassign 	: false,
		})
	}

	toggleOpenModalReassign(data){
		PresenterReadReservationCheck(
			ReadPropsReservationCheck(
				'read', 
				this, 
				this.onReservationCheckSuccess, 
				this.onReservationCheckFailed, 
				data
			)
		)
	};

	onReservationCheckSuccess(params, response){
		if(response.data.result){
			this.setState({
				assetData 		: params.data.Data.Asset,
				userData 		: params.data.Data.User,
				modalReassign 	: true,
			})
		}
	};

	onReservationCheckFailed(response){
		toast.error(response.data.detail)
	};

	scrollToBottom(val = 999999){
		try{
	    	this.chatHistory.scrollTo(0, val)
		}catch(err){
			if(this.chatHistory !== undefined && this.chatHistory !== null){
				let el = this.chatHistory.children[this.chatHistory.children.length - 1]
				if (el){
					el.scrollIntoView();
				}
			}
		}
	};

	handleScroll(event){
		if(event.currentTarget.scrollTop === 0){
			// console.log(this.nextUrl)
			if(this.nextUrl !== null){
				this.setState({
					loadingLoadMore : true
				})
				this.props.OnLoadChat('next',this.props.UserData,this.msgData[0].Alias);
			}
			return
		}else{
			this.setState({
				loadingLoadMore : false
			})
		}
	};

	loadingLoadMore(){
		if(this.state.loadingLoadMore){
			return (
				<div className="text-center">
					<i className="fa fa-refresh fa-spin fa-2x fa-fw"></i>
				</div>
			);
		}else{
			return null;
		}
	};

	generateMessage(msg){
		let date, dateEl;
		this.msgData 	= msg;
		this.msgElement = msg.map((val, index) => {
			const me 		= val.Sender === this.props.UserReducer.username
			const msgDate 	= moment(val.CreatedTime).format('ll')
			if (msgDate !== date){
				dateEl = (
					<div className = "chat-date" key={'date'+index}>
						<div className="chat-message-content">
							<span>{msgDate}</span>
						</div>
					</div>
				)
				date 	= msgDate
			}else{
				dateEl 	= null
			}
			return (
				[dateEl,
				<div className={"chat-message clearfix"} key={'chat'+index}>
					{/*<img src="http://lorempixum.com/32/32/people" alt="" width="32" height="32" />*/}
					<Linkify className="chat-message-content clearfix" key={'Linkify'+index}>
						<span className="chat-time" key={'span'+index} style={{float : (me ? 'left' : 'right')}}>
							<i className="fa fa-clock-o" aria-hidden="true"></i>
							&nbsp;{moment(val.CreatedTime).format('LT')}
						</span>
						<h4  
							key={'h4'+index}
							className = "chat-message-sender" 
							style={{textAlign : (me ? 'right' : 'left')}}
						>
							<strong>{ me ? 'Me' : this.props.UserData.FirstName }</strong>
						</h4>
						<div key={'div'+index}
							className	= "chat-message-body"
							style		= {{
								width 		: '80%',
								marginLeft 	: (me ? '20%' : 0)
							}}
						>
							<p key={'p'+index} style={{float :  (me ? 'right' : 'left')}} >
								{Module.MessageEditor(
									val, true,
									this.toggleOpenModalReassign
								).Content}
							</p>
						</div>
					</Linkify>
					<hr />
				</div>]
			)
		});
		return this.msgElement;
	};

	sendMessage(e){
		if(e.key === 'Enter' && e.target.value.trim() !== ''){
			this.RegisterParams = {
	            Content : e.target.value,
	            ToUser 	: this.props.UserData.Username
	        };

			Presenter.RegisterChatMessage( 
            	RequestProperties.RegisterChatMessage("Send", this, this.onRegisterMessageSuccess, this.onRegisterMessageFailed) 
		    );
		    
			e.target.value = '';
			return;
		}else{
			return;
		}
	};

    onRegisterMessageSuccess(params, response){
    	if (typeof(this.props.OnMessageSent) === 'function'){
    		this.props.OnMessageSent(
    			response.data,
    			this.props.UserData.Username
    		)
    	}
    };

    onRegisterMessageFailed(params, response){
        console.log("On Register Error");
        console.log(response);
    };

    //======================= LIFE CYCLE ========================//

	componentWillReceiveProps(nextProps){
		// console.log('componentWillReceiveProps')
		const isSameMsg = nextProps.MessageData.length === this.state.listMessage.length

		if (nextProps.MessageData.length > 0 && nextProps.MessageData !== null && isSameMsg === false){
			this.setState({
				listMessage 	: this.generateMessage(nextProps.MessageData)
			});
			this.nextUrl 			= nextProps.NextUrl;
			this.newScrollHeight 	= $(this.chatHistory)[0].scrollHeight;
			this.scrollPos 			= this.newScrollHeight - this.scrollHeight
			this.scrollHeight 		= this.newScrollHeight

			if(this.isMinimize){
				if(nextProps.IsRegenerate === false){
					Notify.play();
				}
				this.setState({
					msgCounter 	: nextProps.MessageData.length - this.msgCount
				});
			}

			if(nextProps.ShouldScroll){
				setTimeout(this.scrollToBottom, 100);
			}else{
				setTimeout(this.scrollToBottom(this.scrollPos), 100);
			}
		}else{
			return
		}
	};

	componentDidMount(){
		if(this.props.MessageData.length > 0 && this.props.MessageData !== null){
			this.setState({
				listMessage : this.generateMessage(this.props.MessageData)
			});
			this.scrollHeight = $(this.chatHistory)[0].scrollHeight;
		}
		setTimeout(this.scrollToBottom, 100);
	};
	 

	render(){
		return (
			<div id="live-chat" ref="chatBox" style={{ width : this.props.Width, right : this.props.Right }}>
			    <header className="clearfix" role="button" onClick={() => this.toggleChatBox()} >
			        <a className="chat-close" onClick={(e) => this.toggleCloseChatBox(e)}><i className="fa fa-times-circle" /></a>
			        <h4><i className="chat-bullet" style={{ background : (this.props.UserData.Online || this.props.IsBot ? '#1a8a34' : '#403e3e') }}>
			        	</i>{this.props.UserData.FirstName + ' ' + this.props.UserData.LastName}
			        </h4>
			        {this.state.msgCounter > 0 ? 
			        	<span 
			        		className="chat-message-counter" 
			        		ref="chatCounter" 
			        	>
				        	{this.state.msgCounter > 99 ? '99+' : this.state.msgCounter}
			        	</span> 
			        	: 
			        	null
			        }
			    </header>
			    <div className="chat" ref="chatBody">
			        <div 
			        	className="chat-history" 
			        	ref={(el) => { this.chatHistory = el; }}
			        	id="chatHistory"
			        	onScroll={this.handleScroll}
			        >
			        	{this.loadingLoadMore()}
			            {this.state.listMessage}
			        </div>
			        <div>
			            <fieldset>
			                <input 
			                	type 		= "text" 
			                	ref 		= "chatText"
			                	placeholder = {this.props.IsBot ? "You can't reply this message" : "Type your message…"} 
			                	onKeyPress 	= {(e) => this.sendMessage(e)}
			                	disabled 	= {this.props.IsBot}
			                />
			            </fieldset>
			        </div>
			    </div>
			    <ModalReasign 
			    	selectedItem  		= {this.state.assetData}
				    modalState    		= {this.state.modalReassign}
				    closeModal    		= {this.toggleCloseModalReassign.bind(this)} 
						userData      		= {[this.state.userData]}
        		onReassignSuccess = {this.toggleCloseModalReassign.bind(this)}
						isPerUser     		= {true}
						UserReducer   		= {this.props.UserReducer}
			    />
			</div>
		);
	};
}


// WEBPACK FOOTER //
// ./src/App/chat/ChatBox/helper/component/ChatBox.js